/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_filters__value_label__min_stars__other = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Sterne und mehr`
};

const en_poi_filters__value_label__min_stars__other = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} stars and more`
};

const es_poi_filters__value_label__min_stars__other = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} estrellas y más`
};

const fr_poi_filters__value_label__min_stars__other = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} étoiles et plus`
};

const it_poi_filters__value_label__min_stars__other = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} stelle e più`
};

const nl_poi_filters__value_label__min_stars__other = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} sterren en meer`
};

const pt_poi_filters__value_label__min_stars__other = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} estrelas e mais`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__other = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_filters__value_label__min_stars__other(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_filters__value_label__min_stars__other", locale)
	if (locale === "de") return de_poi_filters__value_label__min_stars__other(inputs)
	if (locale === "en") return en_poi_filters__value_label__min_stars__other(inputs)
	if (locale === "es") return es_poi_filters__value_label__min_stars__other(inputs)
	if (locale === "fr") return fr_poi_filters__value_label__min_stars__other(inputs)
	if (locale === "it") return it_poi_filters__value_label__min_stars__other(inputs)
	if (locale === "nl") return nl_poi_filters__value_label__min_stars__other(inputs)
	return pt_poi_filters__value_label__min_stars__other(inputs)
};